// src/pages/share/index.js 之類路徑
import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom"; // ★ 新增 useSearchParams
import "./styles/share.scss";
import { motion } from "framer-motion";
import axios from "axios";
import { backend } from '../../components/apipath';
import Sharearea from "../home/components/sharearea";

function Share() {
  const [groupedData, setGroupedData] = useState([]);
  const [sharesEssence, setSharesEssence] = useState([]);
  const [selectedCard, setSelectedCard] = useState([]);

  // ★ 讀取網址上的 ?group=...
  const [searchParams] = useSearchParams();
  const urlGroup = searchParams.get("group"); // 可能是 'CPA' | 'CMA' | 'SCE' | null
    // ★ 原始網址 group
  const rawGroup = searchParams.get("group");

  const mappedGroup = rawGroup === "CSU" ? "SCE" : rawGroup;

  const initialGroup =
    mappedGroup === "CPA" || mappedGroup === "CMA" || mappedGroup === "SCE"
      ? mappedGroup
      : "CPA";
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${backend}share/sharesEssence`);
        setSharesEssence(response.data);
        // console.log(response.data);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 8;
  const totalCards = Object.values(groupedData).flat().length;
  const totalPages = Math.ceil(totalCards / cardsPerPage);
  const startIndex = (currentPage - 1) * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;
  const currentCards = Array.isArray(groupedData)
    ? groupedData.slice(startIndex, endIndex)
    : [];

  const getPageNumbersToShow = () => {
    const maxPageNumbersToShow = 10;
    const middlePage = currentPage;
    const halfMaxPageNumbersToShow = Math.floor(maxPageNumbersToShow / 2);

    let startPage = middlePage - halfMaxPageNumbersToShow;
    let endPage = middlePage + halfMaxPageNumbersToShow;

    if (startPage <= 0) {
      startPage = 1;
      endPage = Math.min(totalPages, maxPageNumbersToShow);
    }

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, totalPages - maxPageNumbersToShow + 1);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  // more 按鈕資料
  const handleMoreClick = (item) => {
    setSelectedCard(item);
  };

  return (
    <>
      {/* banner */}
      <div className="banner">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{
            delay: 0.4,
            default: { ease: "linear" },
          }}
        >
          <img src="./shareImg/share.jpg" alt="" />
        </motion.div>
      </div>

      {/* share */}
      <div className="container">
        <div className="beckertitlename text-center mb100">歷年心得分享</div>
        <div className="container">
          {/* ★ 把 initialGroup 傳給 Sharearea */}
          <Sharearea initialGroup={initialGroup} />
        </div>
      </div>
    </>
  );
}

export default Share;
